import React, { ReactNode } from "react";
import { Permission } from "api";
import { PermissionType } from "hooks";

interface PermissionWrapperProps {
    name: PermissionType;
    permissions?: Permission[];
    children: (props: { disabled: boolean; tooltip: string }) => ReactNode;
}

export const PermissionWrapper: React.FC<PermissionWrapperProps> = ({ name, permissions = [], children }) => {
    const permission = permissions.find((permission) => permission.name === name);

    if (!permission || (!permission.display && !permission.enabled)) {
        return null;
    }

    return <>{children({ disabled: !!permission?.display, tooltip: permission?.reason || "" })}</>;
};
